/**
 * URL-param parsing — mirrors
 *   packages/amgfootball_v2/lib/core/utils/url_params.dart
 * (web branch only; no LocalStorage path)
 */
import {
  DEFAULT_AGENT_ID,
  DEFAULT_USER_NAME,
  GAME_KEY_MULTI,
} from '../config';

export interface UrlParams {
  token: string | null;
  gsid: string | null;
  userName: string;
  agentId: string;
  isSound: boolean;
  exitUrl: string | null;
  /** Raw game key from the `g` query param (e.g. 'SSC1', 'SSCM'); null if absent. */
  gameKey: string | null;
  /**
   * Resolved game mode, derived from how the lobby launches the game:
   *   - single: `/?g=SSC1`                (g = GAME_KEY_SINGLE)
   *   - multi:  `/goalshootinghub?g=SSCM` (g = GAME_KEY_MULTI)
   * Either signal (the `g` key or the `/goalshootinghub` path) flags multi;
   * everything else defaults to single. Replaces the launch-time mode dialog.
   */
  gameMode: 'single' | 'multi';
}

export function loadUrlParams(): UrlParams {
  const q = new URLSearchParams(window.location.search);
  const gameKey = q.get('g');
  return {
    token: q.get('token'),
    gsid: q.get('gsid'),
    userName: q.get('user') ?? q.get('userName') ?? DEFAULT_USER_NAME,
    agentId: q.get('agentId') ?? DEFAULT_AGENT_ID,
    isSound: q.get('isSound') === 'true' || q.get('isSound') === '1',
    exitUrl: q.get('exitUrl'),
    gameKey,
    gameMode: resolveGameMode(gameKey, window.location.pathname),
  };
}

/**
 * Resolve single vs multi from the lobby launch URL. The lobby routes
 * multiplayer to `/goalshootinghub?g=SSCM` and single-player to `/?g=SSC1`,
 * so either the `g` game key or the path is enough to flag multiplayer.
 */
function resolveGameMode(
  gameKey: string | null,
  pathname: string,
): 'single' | 'multi' {
  const isMulti =
    gameKey === GAME_KEY_MULTI || /goalshootinghub/i.test(pathname);
  return isMulti ? 'multi' : 'single';
}
